export default {
  FETCH_SURVEY_QUESTIONS: 'FETCH_SURVEY_QUESTIONS',
  SUBMIT_SURVEY_ANSWERS: 'SUBMIT_SURVEY_ANSWERS'
};
